import { createRoot } from "react-dom/client";
import "./index.css";
import NetworxProviders from "../../providers/NetworxProviders";
import { ThemeProvider as NextThemesProvider } from "next-themes";

import HomePage from "./HomePage";
import ToastTray from "@/components/ToastTray";

import "../page";

const domNode = document.getElementById("app");
if (!domNode) {
  throw new Error("Could not find the app root element");
}
const root = createRoot(domNode);

root.render(
  <NetworxProviders>
    <NextThemesProvider attribute="class" forcedTheme="networx-2026">
      <ToastTray />
      <HomePage />
    </NextThemesProvider>
  </NetworxProviders>
);
